<template>
  <div>
    <ul class="nav">
      <li class="nav-item"><span class="nav-link">&nbsp;</span>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    name: 'General'
  }
</script>
